<script>
  import FilterBar from '../components/FilterBar.svelte'
  import { formatRelative } from "date-fns";
  import UserPicture from '../components/UserPicture.svelte';
  import Select from 'svelte-select'
  import notyf from '../utils/notyf'
  import authApi from '../authApi'
  import {XCircleIcon, Trash2Icon} from 'svelte-feather-icons'
  import {roleMap, userRoleNames} from '../auth'
  import AsyncButton from '../components/AsyncButton.svelte';
  
  const tabTypes = ["Users"]

  const users = authApi.endpoint('users')
  const groups = authApi.endpoint('groups')
  const loadAwait = [groups.get(), users.get()]

  let filter
  let curTabType = "Users"

  let selectedEntry
  let newRoles
  
  let newAliases = []
  let newAlias = ''

  $: needsSave = selectedEntry && (
    (newRoles && newRoles.sort().toString() !== selectedEntry.roles.sort().toString()) ||
    (newAliases.sort().toString() !== selectedEntry.emailAliases.sort().toString()))

  function sortUsers(users, userFilter) {
    if (!users) return []
    userFilter = userFilter ? userFilter.toLowerCase() : null
    return [...users.values()].filter(u => userFilter ? u.displayName.toLowerCase().includes(userFilter) : true).sort((a, b) => a.displayName.localeCompare(b.displayName))
  }

  function selectionChanged(ev) {
    newRoles = ev?.detail?.map(e => e.value) ?? []
  }

  async function saveUser() {
    try {
      await users.update(selectedEntry.id, { 
        roles: newRoles,
        emailAliases: newAliases,
      })
      newRoles = null
    } catch (error) {
      notyf.error("Error saving the role changes.") 
    }
  }

  function addAlias() {
    newAliases = [ ...newAliases, newAlias]
    newAlias = ''
  }

  function setSelectedEntry(newEntry) {
    if (newEntry === selectedEntry) newEntry = null
    if (newEntry) {
      if (!newEntry.emailAliases) newEntry.emailAliases = []
      newAliases = [ ...newEntry.emailAliases ]
    }
    selectedEntry = newEntry
  }

    
</script>

<svelte:head>
	<title>SkyLine - Admin</title>
</svelte:head>

{#await loadAwait}
  Loading...
{:then _}
  <div class='adminArea'>
    <header>
			<FilterBar hideNew={true} bind:filter />
    </header>
    <div class='listContainer'>
      {#if curTabType == "Users"}
        <table class="tableList usersTable">
          <thead class="tableEntry">
            <tr class="tableHeader">
              <th class='pic' />
              <th class=''>Display Name</th>
              <th class=''>Email</th>
              <th class=''>Last Login</th>
              <th class=''>Groups</th>
            </tr>
          </thead>
          <tbody>
            {#each sortUsers($users, filter) as user}
              <tr class='tableEntry' class:selected={selectedEntry == user} on:click={() => setSelectedEntry(user)}>
                <td class='pic'>
                  <UserPicture {user} />
                </td>
                <td>{user.displayName}</td>
                <td>{user.email}</td>
                <td>{formatRelative(new Date(user.lastLogin), new Date())}</td>
                <td>{userRoleNames(user.roles)}</td>
              </tr>
            {/each}
          </tbody>
        </table>
      {/if}
    </div>
    {#if selectedEntry}
      <div class="entryView">
        <div>
          <div class='preheader'>
            <div class='close' on:click={() => setSelectedEntry(null)}><XCircleIcon /></div>
          </div>
          <header>
            <UserPicture big user={selectedEntry} />
            <h3>{selectedEntry.displayName}</h3>
          </header>
          <div class='details'>
            <div>Email</div>
            <div>{selectedEntry.email}</div>
            <div>First Login</div>
            <div>{formatRelative(new Date(selectedEntry.createdAt), new Date())}</div>
            <div>Last Login</div>
            <div>{formatRelative(new Date(selectedEntry.lastLogin), new Date())}</div>
            <div>Provider ID</div>
            <div>{selectedEntry.providerId}</div>
            <div>Groups</div>
          </div>
          <Select
            items={Object.entries(roleMap).map(([value, label]) => {return {value, label}})}
            value={selectedEntry.roles.map(e => {return {value:e, label:roleMap[e]}})}
            placeholder="Roles"
            showIndicator
            isMulti
            listOffset={0}
            on:select={selectionChanged}
          />
          <div class="aliases">
            <h4>Email Aliases</h4>
            {#each newAliases as alias, i}
              <div class="alias">
                <span>{alias}</span>
                <div class="trash" on:click={() => { newAliases.splice(i, 1); newAliases = newAliases }} on:keypress={() => newAliases.splice(i, 1)}><Trash2Icon size=16 strokeWidth=1 /></div>
              </div>
            {/each}
            <form class="newAlias" on:submit|preventDefault={addAlias}>
              <input type="text" placeholder="New Alias" bind:value={newAlias}> 
              <button>Add Alias</button>
            </form>
          </div>
        </div>
        {#if needsSave}
          <AsyncButton color="green" handler={saveUser}>Save Changes</AsyncButton>
        {/if}
      </div>
    {/if}
  </div>
{/await}

<style>
  .adminArea {
    display: grid;
		grid-template-columns: minmax(0, 3fr) auto;
		grid-template-rows: auto 1fr;
    background-color: gray;
  }

  .adminArea > header {
    display: flex;
		align-items: center;
		background-color: gray;
		padding: 8px;
  }


	.typeFilters {
		background-color: lightgray;
		display: flex;
		border-radius: 8px;
		margin-right: 8px;
		overflow: hidden;
		user-select: none;
	}

	.tab {
		padding: 8px;
		width: 80px;
		text-align: center;
		cursor: pointer;
	}

	.tab.selected {
		background-color: white;
	}

	.typeFilters > div:not(:last-child) {
		border-right: 1px solid darkgrey;
	}

  /** Table CSS */
  .listContainer {
		grid-row: 2;
		overflow: auto;
		background: grey;
	}

  .tableHeader {
		border-top: 1px solid lightgray;
		border-bottom: 2px dotted gray;
		font-weight: bold;
		font-size: 11pt;
		background-color: lightgray;
		cursor: initial;
		top: 0;
	}

  .tableList {
		width: 100%;
		border-collapse: collapse;
	}

	th {
		text-align: left;
	}
	td {
		/* text-align: right; */
	}

  .tableEntry {
		cursor: pointer;
		color: black;
		background: lightgray;
		/* padding: 1rem; */
		border-bottom: 1px solid #e3e3e3;
    height:46px;
	}

	.tableEntry div {
		/* flex: 25%; */
	}

	.tableEntry:not(.deviceListHeader):hover {
		background-color: rgb(180, 180, 180);
	}

	.tableEntry.selected,
	.tableEntry.selected:hover {
		background: white;
	}

	.tableEntry img {
		margin: 4px;
	}

  .usersTable .pic {
    width:40px;
    padding-left:4px;
    padding-right:4px;
    vertical-align: center;
  }

  /** Sidebar Entry View */
  .entryView {
    grid-row: span 2;
		height: 100%;
    width:20vw;
    min-width: 300px;

    background-color: lightgray;
		color: black;
		padding: 2em;
		box-shadow: -8px 10px 36px 0px rgba(0,0,0,0.75);

		display:grid;
		grid-template-columns: auto;
		grid-template-rows: minmax(0, 1fr) auto;
  }

  .entryView header {
    display:flex;
    align-items: center;
    flex-direction: column;
  }

  /** Details grid */
  .details {
		display: grid;
		grid-template-columns: 40% 60%;
		justify-items: stretch;
		grid-row-gap: 0.8rem;
		align-items: center;
		margin-bottom: 8px;
	}

	.details div:nth-child(odd) {
		color: gray;
		font-weight:bold;
	}

	.details div:nth-child(even) {
		text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
	}

  button {
    margin-top:8px;
  }

  .close {
		color:gray;
		cursor: pointer;
		text-align:right;
		display:flex;
		align-items: center;
		margin-left:8px;
	}
	.close:hover {
		color:black;
	}

  .preheader {
		display:flex;
		align-items: center;
		justify-content: end;
		margin-bottom:8px;
	}

  .trash {
    display: none;
    cursor: pointer;
  }
  .alias {
    display: flex;
    justify-content: space-between;
  }
  .alias span {
    padding: 8px 4px;
  }
  .alias:hover .trash {
    display: initial;
  }
  .newAlias input {
		background:#e3e3e3;
    color: black;
  }
  .newAlias input::placeholder {
    color: darkgrey;
  }
</style>